enum Routes {
  Home = '/',
  About = '/about',
  Contact = '/contact',
  Documentation = '/documentation',
  BecomeARooter = '/become-a-rooter',
}

export { Routes }
